import { searchShowOnMapClick } from 'analytics/eventDefinitions'
import { addGTMEvent } from 'api/googleTagManager'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import FormatInlineList from 'components/utils/Formatters/FormatInlineList'
import React, { MouseEventHandler, useCallback } from 'react'
import * as Analytics from 'analytics/analytics'
import { pushWithRegion } from 'actions/NavigationActions'
import { useAppDispatch } from 'hooks/reduxHooks'

interface Props {
  locations: Array<string>
  mapUrl?: string
}

function SearchTileRowOverlineLocation({ locations, mapUrl }: Props) {
  const dispatch = useAppDispatch()

  const mapViewClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.stopPropagation()
    event.preventDefault()

    Analytics.trackClientEvent({
      subject: 'show_on_map',
      action: 'clicked',
      type: 'interaction',
      category: 'vertical_page',
    })

    addGTMEvent(searchShowOnMapClick())

    if (mapUrl) {
      dispatch(pushWithRegion(mapUrl))
    }
  }, [mapUrl, dispatch])

  return <BodyText variant="small" colour="neutral-two">
    <FormatInlineList list={locations} type="unit" />
    {!!mapUrl && <>{' '}&middot; <TextLink
      weight="regular"
      onClick={mapViewClick}
      role="link"
      data-href={mapUrl}
      aria-label="Show on map"
    >
      Show on map
    </TextLink>
    </>}
  </BodyText>
}

export default SearchTileRowOverlineLocation
